module.exports = __webpack_public_path__ + "a17d279f/img/pdf-icon.79f04a36.svg";